import wixLocation from 'wix-location';
import { getPostsByCategory } from "backend/queries.jsw";

const baseURL = wixLocation.baseUrl
const categoryBtnSVG = {
    down: 'https://static.wixstatic.com/shapes/0d6674_df365fae35f042cf840b6fc13fe367fb.svg', //arrow down
    up: 'https://static.wixstatic.com/shapes/0d6674_421dd67fb9fa4fd9b285aa7999aa5aa0.svg' // arrrow up
}

$w.onReady(function () {
    $w('#goBackC').collapse();
    // resetUI();
    dropDownToggleHandler();
});

function setDataToRepeater(repeaterId, data) {
    $w(repeaterId).data = data;
}

function dropDownToggleHandler() {
    $w('#dropDownBtn').icon = categoryBtnSVG.down;
    $w('#dropDownBtn').onClick(() => {
        $w('#dropDownBtn').icon === categoryBtnSVG.down ? (
            $w('#dropDownBtn').icon = categoryBtnSVG.up,
            $w('#categoriesBox').show()
        ) : (
            $w('#dropDownBtn').icon = categoryBtnSVG.down,
            $w('#categoriesBox').hide()
        );
    })
    /* the line above is the same as: 
     $w('#dropDownBtn').onClick(() => {
          if ($w('#dropDownBtn').icon === categoryBtnSVG.down) {
              $w('#dropDownBtn').icon = categoryBtnSVG.up;
              $w('#categoriesBox').show();
          } else {
              $w('#dropDownBtn').icon = categoryBtnSVG.down;
              $w('#categoriesBox').hide();
          }
      }) */
}

/**
*	Sets the function that runs when a new repeated item is created.
	[Read more](https://www.wix.com/corvid/reference/$w.Repeater.html#onItemReady)
*	 @param {$w.$w} $item
*/
export function eventsRepeater_itemReady($item, itemData) {
    //TEMP
    if (itemData.locationName === "Community event") {
        $item('#repEventsEventTypeColor').style.backgroundColor = '#FF554C';
    }

}


export async function productReleasesRepeater_itemReady($item, itemData) {
    let timeAgo = await time_ago(itemData.postCreatedDate);
    // $item('#slugAndCategory').html = `<p>${itemData.nickname} • ${itemData.category}</p>`;
    $item('#slugAndCategory').html = `<p>${itemData.nickname} • ${timeAgo}</p>`;
    $item('#pReleasesTitle').html = `<p><a href="${baseURL + itemData.pageUrl}" target="_self">${itemData.title}</a></p>`;
}

export function showcaseRepeater_itemReady($item, itemData) {
    console.log(itemData)
    let timeAgo = time_ago(itemData.postCreatedDate);
    $item('#SCpostSlugAndCategory').html = `<p>${itemData.nickname} • ${itemData.category}</p>`;
    $item('#SCtimeAgo').text = timeAgo;
    $item('#SCtitle').html = `<p><a href="${baseURL + itemData.pageUrl}" target="_self">${itemData.title}</a></p>`;

    if ('profilePhoto' in itemData) {
        $item('#SCprofilePhoto').src = itemData?.profilePhoto.replace('http://', 'https://');
    }
    $item('#SCprofilePhoto').show();
}

export function categoriesRepeater_itemReady($item, itemData) {
    $item("#categoryBtn").onClick(async () => {
        // console.log(itemData._id)
        const categoryData = await getPostsByCategory(itemData._id)
        // console.log(categoryData)
        setDataToRepeater('#filteredPostsRepeater', categoryData.posts);
        $w('#dropDownBtn').label = itemData.name;
        $w('#dropDownBtn').icon = categoryBtnSVG.down;
        $w('#categoriesBox').hide()
    })
}

//******************//
//   RECENT POSTS   
//******************//
export async function filteredPostsRepeater_itemReady($item, itemData) {
    // console.log(itemData)
    let timeAgo = await time_ago(itemData.createdDate || itemData._createdDate);
    $item('#slug').html = `<p>${itemData.nickname} • ${itemData.category}</p>`;
    $item('#title').html = `<p><a href="${baseURL + itemData.pageUrl}" target="_self">${itemData.title}</a></p>`;
    $item('#plainContent').html = `<p>${itemData.plainContent + " "}<a href="${itemData.pageUrl}" target="_self" style="font-family:madefor-text-mediumbold,helveticaneuew01-45ligh,helveticaneuew02-45ligh,helveticaneuew10-45ligh,sans-serif !important;;">Read more...</a></p>`
    $item('#timeAgo').text = timeAgo;
    if ('profilePhoto' in itemData) {
        $item('#profilePhoto').src = itemData?.profilePhoto.replace('http://', 'https://');
    }
    $item('#profilePhoto').show();

    // console.log(itemData.title.split(1))
}

//**************//
//    HELPERS   
//**************//

// convert date into time from now. can get date as unix, string or object 
function time_ago(time) {
    switch (typeof time) {
    case 'number':
        break;
    case 'string':
        time = +new Date(time);
        break;
    case 'object':
        if (time.constructor === Date) time = time.getTime();
        break;
    default:
        time = +new Date();
    }

    let time_formats = [
        [60, 's', 1],
        [3600, 'm', 60],
        [86400, 'h', 3600],
        [604800, 'd', 86400],
        [29030400, 'w', 604800],
        [2903040000, 'y', 29030400],
    ];
    let seconds = (+new Date() - time) / 1000,
        list_choice = 1;

    if (seconds == 0) {
        return 'Now'
    }
    if (seconds < 0) {
        seconds = Math.abs(seconds);
        list_choice = 2;
    }
    let i = 0,
        format;

    while ((format = time_formats[i++]))
        if (seconds < format[0]) {
            if (typeof format[2] == 'string')
                return format[list_choice];
            else
                return Math.floor(seconds / format[2]) + '' + format[1];
        }
    return time;
}

function resetUI() {
    $w('#filteredPostsRepeater').data = [];
    $w('#productReleasesRepeater').data = [];
    $w('#showcaseRepeater').data = [];
}

/**
*	Sets the function that runs when a new repeated item is created.
	[Read more](https://www.wix.com/corvid/reference/$w.Repeater.html#onItemReady)
*	 @param {$w} $item
*/
export function leadersRepeater_itemReady($item, itemData) {
    $item("#colorfulCircle").style.borderColor = itemData.circleColor;
    itemData.instagramLink && $item('#instaIcon').expand();
    itemData.linkedInLink && $item('#linkedInIcon').expand();
    itemData.twitterLink && $item('#twitterIcon').expand();
}

export function box216_click(event) {
console.log(event.target)
}